const config = {
  backendApiUrl: process.env.REACT_APP_BACKEND_API_URL ?? '',
  niOrchestratorUrl: process.env.REACT_APP_NI_ORCHESTRATOR_URL ?? '',
  referralUrl: process.env.REACT_APP_REFERRAL_URL ?? '',
  ambassadorUrl: process.env.REACT_APP_AMBASSADOR_URL ?? '',
  userServiceUrl: process.env.REACT_APP_USER_SERVICE_URL ?? '',
  appUrl: process.env.REACT_APP_URL ?? ''
};

export default config;

export async function loadConfig() {
  try {
    const res = await fetch('/safetywing-frontend/config');
    if (!res.ok) throw new Error(`/config responded with ${res.status}`);
    const data = await res.json();
    if (data.backendApiUrl) config.backendApiUrl = data.backendApiUrl;
    if (data.niOrchestratorUrl) config.niOrchestratorUrl = data.niOrchestratorUrl;
    if (data.referralUrl) config.referralUrl = data.referralUrl;
    if (data.ambassadorUrl) config.ambassadorUrl = data.ambassadorUrl;
    if (data.userServiceUrl) config.userServiceUrl = data.userServiceUrl;
    if (data.appUrl) config.appUrl = data.appUrl;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(
      'Failed to load runtime config, falling back to build-time env vars',
      err
    );
  }

  if (!config.backendApiUrl) throw new Error('backendApiUrl missing in config');
  if (!config.niOrchestratorUrl) throw new Error('niOrchestratorUrl missing in config');
  if (!config.referralUrl) throw new Error('referralUrl missing in config');
  if (!config.ambassadorUrl) throw new Error('ambassadorUrl missing in config');
  if (!config.userServiceUrl) throw new Error('userServiceUrl missing in config');
  if (!config.appUrl) throw new Error('appUrl missing in config');
}
